export const fetchAgg = async ({
	siteId,
	graphQuery,
	variables,
}: {
	siteId?: string;
	graphQuery: string;
	variables: any;
}) => {
	const response = await fetch('/gateway/api/graphql', {
		headers: {
			'Content-Type': 'application/json',
		},
		method: 'POST',
		body: JSON.stringify({
			query: graphQuery,
			variables: {
				siteAri: siteId ? `ari:cloud:confluence::site/${siteId}` : undefined,
				...variables,
			},
		}),
	});

	const json = await response.json();

	return json;
};
